import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaBroadcastTower } from 'react-icons/fa';
import '../styles/AddToPartyBtn.css';

const API = process.env.REACT_APP_API_URL || '';

function AddToPartyBtn({ track }) {
  const [parties, setParties] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [message, setMessage] = useState(null);

  const loadParties = async () => {
    try {
      const res = await axios.get(`${API}/api/party`);
      setParties(res.data);
    } catch (e) {}
  };

  const handleClick = (e) => {
    e.stopPropagation();
    if (parties.length === 0) loadParties();
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    if (showDropdown && parties.length === 0) loadParties();
  }, [showDropdown]);

  const addToParty = async (partyId, e) => {
    e.stopPropagation();
    try {
      await axios.post(`${API}/api/party/${partyId}/queue`, { track_id: track.id });
      setMessage('Ajouté !');
      setTimeout(() => { setMessage(null); setShowDropdown(false); }, 1500);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Erreur');
      setTimeout(() => setMessage(null), 2000);
    }
  };

  return (
    <div className="add-to-party-wrapper">
      <button className="track-action-btn party-add-btn" onClick={handleClick} title="Ajouter à une Listening Party">
        <FaBroadcastTower />
      </button>
      {showDropdown && (
        <div className="party-dropdown" onClick={e => e.stopPropagation()}>
          {message ? (
            <div className="party-dropdown-msg">{message}</div>
          ) : parties.length === 0 ? (
            <div className="party-dropdown-empty">Aucune party active</div>
          ) : (
            <>
              <div className="party-dropdown-title">Ajouter à une Party</div>
              {parties.map(p => (
                <div key={p.id} className="party-dropdown-item" onClick={(e) => addToParty(p.id, e)}>
                  <span className="party-dropdown-name">{p.name}</span>
                  <span className="party-dropdown-meta">{p.member_count} membres</span>
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default AddToPartyBtn;
